import type Action from 'constants/action-types'
import {
  SET_LOGS_DATA,
  APPEND_LOGS_DATA,
  SET_LOGS_NEXT_TOKEN_DATA,
  SET_FETCHING_LOGS_DATA,
  SET_FETCHING_MORE_LOGS_DATA,
  CLEAR_LOGS_DATA,
} from 'constants/action-types'
import type { LogsState } from 'types/search/logs'

const initialState: LogsState = {
  items: [],
  nextToken: null,
  isFetching: false,
  isFetchingMore: false,
}

const logsReducer = (
  state: LogsState = initialState,
  action: Action,
): LogsState => {
  switch (action.type) {
    case SET_LOGS_DATA:
      return {
        ...state,
        items: action.payload,
      }

    case APPEND_LOGS_DATA:
      return {
        ...state,
        items: [...state.items, ...action.payload],
        isFetchingMore: false,
      }

    case SET_LOGS_NEXT_TOKEN_DATA:
      return {
        ...state,
        nextToken: action.payload,
      }

    case SET_FETCHING_LOGS_DATA:
      return {
        ...state,
        isFetching: action.payload,
      }

    case SET_FETCHING_MORE_LOGS_DATA:
      return {
        ...state,
        isFetchingMore: action.payload,
      }

    case CLEAR_LOGS_DATA:
      return initialState

    default:
      return state
  }
}

export default logsReducer
